import { titles } from '../../../../../web/styles/colors';
import { CssSelectors } from '../../../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {},
	content: {
		alignItems: 'center',
		boxSizing: 'border-box',
		display: 'flex',
		padding: '15px 0',
		width: '100%',
		...CssSelectors.allChildren(
			{
				marginLeft: 4,
			},
			':not(:first-child)'
		),
	},
	email: {
		alignItems: 'center',
		color: '#858585',
		display: 'flex',
		fontSize: 12,
		maxWidth: '35%',
	},
	name: {
		color: titles,
		fontSize: titles,
		maxWidth: '60%',
	},
	radioButton: {
		width: '100%',
		...CssSelectors.allDescendants(
			{
				alignItems: 'center',
				display: 'flex',
				flexGrow: 1,
				maxWidth: `calc(99% - ${22}px)`,
			},
			'.radio-button-label'
		),
	},
});
